import React, { useEffect, useRef, useState } from 'react';
import PaginationComponent from '../../shared/components/PaginationComponent';
import AddEditCommanTasks from '../components/forms/AddEditCommanTasksTemplate';
import Modal from '../../shared/components/ui/Modal';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Button from '../../shared/components/ui/Button';
import FormInput from '../../shared/components/ui/FormInput';
import { Pencil, Trash, Plus, CirclePlus } from 'lucide-react';
import { SwipeableDrawer } from '@mui/material';
import {
  addSection,
  getAllWorkTypes,
  getAllSections,
  getAllCommonLiveTask,
  getContractorAndArchitect,
  updateLiveTask,
  createCommonLiveTasks,
  makePreviewFalse,
  addCommonLiveTasks,
  updateAllTaskUsers,
  cancelCreatedLiveTask,
  updateAllTaskSPs,
  checkLiveTaskDelete,
  deleteLiveTask,
  bulkDeleteLiveTask,
  assignUsersByCheckbox,
  getTaskTemplates,
  bulkCompleteTasks
} from '../services/api/implementation/impl';
import { useMutation, useQuery } from '@tanstack/react-query';
import DP from '../../shared/assets/svg/noUser.svg';
import toast from 'react-hot-toast';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import noDataIcon from '../../shared/assets/svg/NoData.svg';
import { getUsers } from '../../super-admin/services/api/implementation/impl';
import TaskDetailsPage from './TaskDetailsPage';
import { useNavigate } from 'react-router-dom';
import CalenderIcon from '../../shared/assets/svg/calendar.svg';
import AddEditCommonLiveTask from '../components/forms/AddEditCommanLiveTask';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import { useDispatch, useSelector } from 'react-redux';
import { setFormData } from '../../../uiSlice';
import DeleteConfirmationModal from '../components/ui/DeleteConfirmationModal';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import BulkEngineerAssignmentModal from '../components/layout/BulkEngineerAssignmentModal';
import UserSelectionModal from '../components/forms/UserSelectionModal';
import BulkCompleteModal from '../components/forms/BulkCompleteModal';
import BulkActionModal from '../components/forms/BulkActionModal';
import TableData from '../../shared/components/ui/TableData';
import { useProjectsList } from '../../../contexts/ProjectsContext';
import { AddServiceProvider } from '../components/forms/AddEditServiceProvider';
import { createServiceProvider } from '../services/api/implementation/impl';

const CommanLiveTasks = ({ setisLoading, aiPrefill = null }) => {
  const userId = Cookies.get('userId');
  const { projects, projectsForDropdown, isProjectsLoading } = useProjectsList();
  const dispatch = useDispatch();
  const storedFormData = useSelector((state) => state.ui.formData?.commonTasks || {});

  const validationSchema = yup.object().shape({
    project: yup.string().required('Select Project'),
    workType: yup.string().required('Select work type')
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    control,
    watch
  } = useForm({
    resolver: yupResolver(validationSchema)
  });
  const { collapsed } = useSidebar();
  const [isOpenAddEditModal, setIsOpenAddEditModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [sections, setSections] = useState([]);
  const [barStyle, setBarStyle] = useState({ width: 0, translateX: 0 });
  const [selectedWorkType, setSelectedWorkType] = useState();
  const [tasks, setTasks] = useState([]);
  const [isDateModalOpen, setIsDateModalOpen] = useState(false);
  const [selectedDateType, setSelectedDateType] = useState(''); // 'start' or 'end'
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const [tempDate, setTempDate] = useState(null); // temp selected date
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalData, setModalData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const colors = ['bg-orange-400', 'bg-blue-500', 'bg-green-500', 'bg-purple-500']; // Add more if needed
  const [apiType, setApiType] = useState();
  const navigate = useNavigate();
  const [selectedSection, setSelectedSection] = useState();
  const [hidePreviewBtn, setHidePreviewBtn] = useState(false);
  const [hidePreviewTable, setHidePreviewTable] = useState(false);
  const [previousTask, setPreviousTask] = useState();
  const [unique, setUnique] = useState(false);
  const buttonsRef = useRef([]);

  /**
   * How tall the fixed Project / Work Type bar actually is.
   *
   * Four bars on this page are `position: fixed`, and the two below the tabs
   * were positioned with hand-written rem offsets that assumed a height. The
   * bar is a wrapping form, so its height changes with the viewport — and when
   * it grew past the offset the sub-tab bar below simply painted over its
   * bottom edge, hiding Add Section and the buttons beside it.
   *
   * Measuring removes the assumption. Nothing below has to guess any more.
   */
  const toolbarRef = useRef(null);
  const [toolbarHeight, setToolbarHeight] = useState(0);

  useEffect(() => {
    const node = toolbarRef.current;
    if (!node || typeof ResizeObserver === 'undefined') return undefined;
    const measure = () => setToolbarHeight(node.getBoundingClientRect().height);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(node);
    window.addEventListener('resize', measure);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, []);

  // Where the bar starts: directly under the page tabs, stated rather than
  // left to whatever static position `fixed` happened to inherit.
  const TOOLBAR_TOP_REM = 7.5;
  const subTabTop = `${TOOLBAR_TOP_REM}rem`;

  /**
   * Where the scrolling content may start without going under a fixed bar.
   *
   * The toolbar's measured height plus the sub-tab bar when there is one. It
   * was a flat pt-[10rem], which is why the table sat under the bars whenever
   * the toolbar wrapped onto a second line.
   */
  const SUBTAB_HEIGHT_REM = 3.5;

  /**
   * The container this sits in already carries mt-[8rem], so that much of the
   * offset is spent before the padding is applied — the old pair was a flat
   * 8rem margin plus a 10rem padding, clearing the bars by addition. Subtract
   * it, or the table lands a screen further down than it should. Clamped at
   * zero for the case where the bars are shorter than the margin.
   */
  const CONTAINER_TOP_REM = 8;
  const contentTop = (hasSections) =>
    `max(0px, calc(${TOOLBAR_TOP_REM}rem + ${toolbarHeight}px + ${
      hasSections ? SUBTAB_HEIGHT_REM : 0
    }rem - ${CONTAINER_TOP_REM}rem))`;
  const userColorMap = {};
  const [allAssignedSPs, setAllAssignedSPs] = useState();
  const projectId = watch('project');
  const workType = selectedWorkType?.id;
  const sectionId = selectedSection;
  const [taskPositionType, setTaskPositionType] = useState();
  const [canDelete, setCanDelete] = useState(null);

  // Engineer bulk assignment modal state
  const [isEngineerBulkAssignModalOpen, setIsEngineerBulkAssignModalOpen] = useState(false);
  // Bulk action modal state
  const [isBulkActionModalOpen, setIsBulkActionModalOpen] = useState(false);

  // Add Service Provider modal state
  const [showAddSPModal, setShowAddSPModal] = useState(false);
  const [isSubmittingSP, setIsSubmittingSP] = useState(false);

  // Mutation for creating service provider
  const { mutate: handleCreateServiceProvider } = useMutation({
    mutationFn: createServiceProvider,
    onMutate: () => {
      setIsSubmittingSP(true);
    },
    onSuccess: async (data) => {
      setIsSubmittingSP(false);
      toast.success('Service Provider created successfully');
      setShowAddSPModal(false);
      // Refetch contractors or architects based on modal title
      if (modalTitle === 'Select Contractors') {
        await ContractorsMutation();
      } else if (modalTitle === 'Select Architects') {
        await ArchitectsMutation();
      }
    },
    onError: (err) => {
      setIsSubmittingSP(false);
      toast.error(
        err?.response?.data?.message || err?.message || 'Error creating service provider'
      );
    }
  });

  const [resData, setResData] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const [isBulk, setIsBulk] = useState(false);
  const [selectItems, setSelectItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isAssignUsersModalOpen, setIsAssignUsersModalOpen] = useState(false);
  const [selectedEngineers, setSelectedEngineers] = useState([]);
  const [selectedContractors, setSelectedContractors] = useState([]);
  const [selectedTasks, setSelectedTasks] = useState([]);
  const [isBulkCompleteModalOpen, setIsBulkCompleteModalOpen] = useState(false);
  const [AllContractors, setAllContractors] = useState([]);
  const [AllArchitect, setAllArchitect] = useState([]);
  const [AllUsers, setallUsers] = useState([]);

  function getUserColor(userId) {
    if (!userColorMap[userId]) {
      const keys = Object.keys(userColorMap);
      userColorMap[userId] = colors[keys.length % colors.length];
    }
    return userColorMap[userId];
  }

  // Track page view
  useEffect(() => {
    mixpanel.track('Comman Live Tasks Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    const activeIndex = sections.findIndex((sec) => sec.section_id === activeTab);

    const activeButton = buttonsRef.current[activeIndex];
    if (activeButton) {
      const { offsetWidth, offsetLeft } = activeButton;
      setBarStyle({ width: offsetWidth, translateX: offsetLeft });
    }
  }, [activeTab, sections]);
  // Add tab change handler

  const handleTabChange = (section_id) => {
    setActiveTab(section_id);
    setSelectedSection(section_id);
    dispatch(
      setFormData({
        subTab: 'commonTasks',
        data: { sectionId: section_id }
      })
    );
  };

  const { data: AllWorkTypes, refetch: fetchWorkTypes } = useQuery({
    queryKey: ['AllWorkTypes'],
    queryFn: getAllWorkTypes
  });

  const { data: TaskTemplates, refetch: refetchTaskTemplates } = useQuery({
    queryKey: ['getTaskTemplates', projectId, selectedWorkType],
    queryFn: () => getTaskTemplates(projectId, 'common', selectedWorkType?.name),
    enabled: !!projectId && !!selectedWorkType,
    refetchOnWindowFocus: true, // Refetch when user comes back to the page
    refetchOnMount: true // Refetch every time component mounts
  });

  // Refetch task templates when component mounts and project is available
  useEffect(() => {
    if (projectId) {
      refetchTaskTemplates();
    }
  }, [projectId, refetchTaskTemplates]);

  const { mutate: UsersMutation } = useMutation({
    mutationFn: () => getUsers(),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (res) => {
      setallUsers(res);
      setIsSubmitting(false);

      // Process users immediately after setting state
      const usersArray = res?.data || res;
      const filteredUsers = usersArray
        .filter((user) => {
          return (
            user.vertical === 'Operations' &&
            Array.isArray(user.userProjectMapping) &&
            user.userProjectMapping.some(
              (mapping) => String(mapping.project_id) === String(projectId)
            )
          );
        })
        .map((user) => ({
          user: {
            id: user.id,
            name: user.name,
            level: user.level
          }
        }));

      setallUsers(filteredUsers);
    },
    onError: (err) => {
      setIsSubmitting(false);
      toast.error(err?.response?.data?.message || err?.message || 'Error fetching users');
    }
  });

  // Handle modal data updates when AllUsers changes
  useEffect(() => {
    if (AllUsers && modalTitle === 'Select Engineers') {
      setModalData(AllUsers);

      // For column add button (bulk assignment), do smart pre-selection
      if (unique) {
        const smartSelectedEngineers = AllUsers.filter((engineer) => {
          const assignedTasks = tasks.filter((task) =>
            task?.engineerLiveTaskMapping?.some((eng) => eng.user?.id === engineer.user?.id)
          );
          return assignedTasks.length === tasks.length && tasks.length > 0;
        }).map((eng) => eng.user?.id);
        setSelectedItems(smartSelectedEngineers);
      }
    }
  }, [AllUsers, modalTitle, unique, tasks]);

  // Handle modal data updates when AllContractors changes
  useEffect(() => {
    if (AllContractors && modalTitle === 'Select Contractors') {
      setModalData(AllContractors?.data);

      // For column add button (bulk assignment), do smart pre-selection
      if (unique) {
        const smartSelectedContractors =
          AllContractors?.data
            ?.filter((contractor) => {
              const assignedTasks = tasks.filter((task) =>
                task?.spLiveTaskMapping?.some(
                  (sp) =>
                    sp?.user?.serviceProvider?.category_id === 1 &&
                    sp.user?.id === contractor.user?.id
                )
              );
              return assignedTasks.length === tasks.length && tasks.length > 0;
            })
            .map((contractor) => contractor.user?.id) || [];

        setSelectedItems(smartSelectedContractors);

        const allAssignedArchitectIds = tasks?.reduce((acc, task) => {
          const architectIds =
            task?.spLiveTaskMapping
              ?.filter((sp) => sp?.user?.serviceProvider?.category_id === 2)
              .map((sp) => sp.user?.id)
              .filter(Boolean) || [];
          return acc.concat(architectIds);
        }, []);
        setAllAssignedSPs([...new Set(allAssignedArchitectIds)]);
      }
    }
  }, [AllContractors, modalTitle, unique, tasks]);

  // Handle modal data updates when AllArchitect changes
  useEffect(() => {
    if (AllArchitect && modalTitle === 'Select Architects') {
      setModalData(AllArchitect?.data);

      // For column add button (bulk assignment), do smart pre-selection
      if (unique) {
        const smartSelectedArchitects =
          AllArchitect?.data
            ?.filter((architect) => {
              const assignedTasks = tasks.filter((task) =>
                task?.architectLiveTaskMapping?.some(
                  (sp) =>
                    sp?.user?.serviceProvider?.category_id === 2 &&
                    sp.user?.id === architect.user?.id
                )
              );
              return assignedTasks.length === tasks.length && tasks.length > 0;
            })
            .map((architect) => architect.user?.id) || [];

        setSelectedItems(smartSelectedArchitects);

        const allAssignedContractorIds = tasks?.reduce((acc, task) => {
          const architectIds =
            task?.architectLiveTaskMapping
              ?.filter((sp) => sp?.user?.serviceProvider?.category_id === 1)
              .map((sp) => sp.user?.id)
              .filter(Boolean) || [];
          return acc.concat(architectIds);
        }, []);
        setAllAssignedSPs([...new Set(allAssignedContractorIds)]);
      }
    }
  }, [AllArchitect, modalTitle, unique, tasks]);

  const { mutate: ContractorsMutation } = useMutation({
    mutationFn: () => getContractorAndArchitect(1),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (res) => {
      setAllContractors(res);
      setIsSubmitting(false);
    },
    onError: (err) => {
      setIsSubmitting(false);
      toast.error(err?.response?.data?.message || err?.message || 'Error fetching contractors');
    }
  });

  const { mutate: ArchitectsMutation } = useMutation({
    mutationFn: () => getContractorAndArchitect(2),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (res) => {
      setAllArchitect(res);
      setIsSubmitting(false);
    },
    onError: (err) => {
      setIsSubmitting(false);
      toast.error(err?.response?.data?.message || err?.message || 'Error fetching architects');
    }
  });

  useEffect(() => {
    // Only call AllSections when both projectId and workType are available
    if (projectId && workType) {
      AllSections(workType);
    }
  }, [projectId, workType]);

  const isQueryEnabled = Boolean(projectId && projectId !== '' && workType);

  const {
    data: allTasks,
    refetch: refetchCommonLiveTask,
    isFetching
  } = useQuery({
    queryKey: ['getAllCommonLiveTask', projectId, workType, sectionId],
    queryFn: () => {
      if (!projectId || !workType) {
        return Promise.resolve([]); // protect against undefined values
      }
      return getAllCommonLiveTask(projectId, workType, sectionId);
    },
    enabled: isQueryEnabled
  });

  useEffect(() => {
    setisLoading(isFetching);
  }, [isFetching]);

  //stare the all vendors in the vendors state
  useEffect(() => {
    if (allTasks?.data) {
      setTasks(allTasks?.data);

      const allAdded = allTasks?.data?.length > 0 && allTasks?.data?.every((task) => task?.isAdded);
      setHidePreviewBtn(allAdded);

      const isPreviewComplete =
        allTasks?.data?.length > 0 && allTasks?.data?.every((task) => !task?.preview);

      setHidePreviewTable(isPreviewComplete);
    }
  }, [allTasks?.data]);

  useEffect(() => {
    if (sections) {
      setSelectedSection(sections[0]?.section_id);
      setActiveTab(sections[0]?.section_id);
    }
  }, [sections]);

  useEffect(() => {
    fetchWorkTypes();
    refetchCommonLiveTask();
  }, []);

  useEffect(() => {
    if (AllWorkTypes?.length > 0) {
      setSections([]);
      setValue('workType', AllWorkTypes?.[0]?.id);
      setSelectedWorkType(AllWorkTypes[0]);
    }
  }, [AllWorkTypes, projectId]);

  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = tasks.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const transformedDataTaskTemplates =
    TaskTemplates?.map((item) => ({
      label: item.name || '',
      id: item.name,
      value: item.name
    })) || [];

  useEffect(() => {
    if (projects) {
      const preferred = aiPrefill?.projectId || projects?.[0]?.id;
      if (preferred) setValue('project', preferred);
    }
  }, [projects, aiPrefill?.projectId, setValue]);

  useEffect(() => {
    if (aiPrefill?.templateName) {
      setValue('template_name', aiPrefill.templateName);
    }
  }, [aiPrefill?.templateName, setValue]);

  const transformedDataWorkTypes =
    AllWorkTypes?.filter((item) => item.type === 'Common') // ✅ filter first
      .map((item) => ({
        label: item.name || '',
        id: item.id,
        value: item.id
      })) || [];

  const HandleCreate = (data) => {
    const payload = {
      project_id: Number(data.project),
      workType_id: Number(data.workType),
      name: data.template_name
    };
    addSections(payload);
  };

  const { mutate: addSections } = useMutation({
    mutationFn: (payload) => addSection(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success('Section created successfully');
      await fetchWorkTypes(); // UI data update
      // Only call AllSections if both projectId and workType are available
      if (projectId && selectedWorkType?.id) {
        AllSections(selectedWorkType.id);
      }
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error creating new section', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error creating section');
    }
  });

  const { mutate: AllSections } = useMutation({
    mutationFn: (workTypeId) => {
      if (!projectId || !workTypeId) {
        throw new Error('Project ID and Work Type ID are required');
      }
      return getAllSections(workTypeId, projectId);
    },
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (res) => {
      setIsSubmitting(false);
      setSections(res);
      setActiveTab(1);
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error fetching sections:', err);
    }
  });

  const handleChangeWorkType = (id) => {
    if (id) {
      const data = AllWorkTypes?.filter((item) => item?.id === Number(id));
      setSelectedWorkType(data[0]);

      dispatch(
        setFormData({
          subTab: 'commonTasks',
          data: { workTypeId: id }
        })
      );
    }
  };

  const handleDateClick = (taskId, type) => {
    setSelectedTaskId(taskId);
    setSelectedDateType(type);
    setIsDateModalOpen(true);
  };

  const handleDateSubmit = () => {
    if (!tempDate || !selectedTaskId || !selectedDateType) return;
    const formattedDate = tempDate?.toLocaleDateString('en-CA');
    let payload = {}; // <-- changed from const to let
    if (selectedDateType === 'start') {
      payload = {
        planned_start_date: formattedDate
      };
    }

    if (selectedDateType === 'end') {
      payload = {
        planned_end_date: formattedDate
      };
    }

    updateTask({ selectedTaskId, payload });
    setIsDateModalOpen(false);
    setTempDate(null);
    setSelectedTaskId(null);
    setSelectedDateType('');
  };

  const { mutate: updateTask } = useMutation({
    mutationFn: ({ selectedTaskId, payload }) => updateLiveTask(selectedTaskId, payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success('Task updated successfully');
      setSelectedItems([]);
      await refetchCommonLiveTask();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error updating task', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error updating task');
    }
  });

  const { mutate: updateTaskUsers } = useMutation({
    mutationFn: (payload) => updateAllTaskUsers(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success('Task updated successfully');
      setSelectedItems([]);
      setUnique(false);
      setAllAssignedSPs();
      await refetchCommonLiveTask();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error updating task', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error updating task');
    }
  });

  const { mutate: updateTaskSPs } = useMutation({
    mutationFn: (payload) => updateAllTaskSPs(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success('Task updated successfully');
      setUnique(false);
      setSelectedItems([]);
      setAllAssignedSPs();
      await refetchCommonLiveTask();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error updating task', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error updating task');
    }
  });

  const toggleSelect = (item) => {
    // Check if this is engineer selection and apply type restrictions
    if (modalTitle === 'Select Engineers') {
      const isSelected = selectedItems.includes(item);
      if (!isSelected) {
        // Check if adding this engineer would exceed limits
        const user = modalData.find((u) => u.user?.id === item);
        if (user && user.user?.level) {
          const selectedEngineers = modalData.filter((u) => selectedItems.includes(u.user?.id));
          const mediumLevelCount = selectedEngineers.filter(
            (u) => u.user?.level === 'Medium'
          ).length;
          const lowLevelCount = selectedEngineers.filter((u) => u.user?.level === 'Low').length;

          if (user.user.level === 'Medium' && mediumLevelCount >= 1) {
            toast.error('Only 1 Medium level engineer can be selected');
            return;
          }
          if (user.user.level === 'Low' && lowLevelCount >= 1) {
            toast.error('Only 1 Low level engineer can be selected');
            return;
          }
        }
      }
    }

    setSelectedItems((prevSelected) => {
      if (prevSelected.includes(item)) {
        return prevSelected.filter((i) => i !== item);
      } else {
        return [...prevSelected, item];
      }
    });
  };

  const handleAddClick = () => {
    // if (!unique) {
    //   if (
    //     (!selectedTaskId || !selectedItems || selectedItems.length === 0) &&
    //     (modalTitle === 'Select Contractors' || modalTitle === 'Select Engineers')
    //   ) {
    //     toast.error('Select any user');
    //     return;
    //   }
    // }

    // if (
    //   (!selectedItems || selectedItems.length === 0) &&
    //   (modalTitle === 'Select Contractors' || modalTitle === 'Select Engineers')
    // ) {
    //   toast.error('Select any user');
    //   return;
    // }

    const ids = tasks.map((task) => task?.id);
    let payload = {}; // <-- changed from const to let
    if (modalTitle === 'Select Contractors' || modalTitle === 'Select Architects') {
      const SPids = [...new Set([...selectedItems])];

      if (modalTitle === 'Select Contractors') {
        payload = {
          sp_ids: SPids,
          taskType: 'Common',
          project_id: projectId,
          workType_id: selectedWorkType.id
        };
      }

      if (modalTitle === 'Select Architects') {
        payload = {
          architect_ids: SPids,
          taskType: 'Common',
          project_id: projectId,
          workType_id: selectedWorkType.id
        };
      }
    }

    if (modalTitle === 'Select Engineers') {
      const selectedEngineers = modalData.filter((u) => selectedItems.includes(u.user?.id));
      const mediumLevelCount = selectedEngineers.filter((u) => u.user?.level === 'Medium').length;
      const lowLevelCount = selectedEngineers.filter((u) => u.user?.level === 'Low').length;

      if (mediumLevelCount !== 1) {
        toast.error('Please select exactly one Manager');
        return;
      }
      if (lowLevelCount > 1) {
        toast.error('Only one Executive can be selected');
        return;
      }

      payload = {
        engineer_ids: selectedItems,
        taskType: 'Common',
        project_id: projectId,
        workType_id: selectedWorkType.id
      };
    }
    // console.log('Selected Items:', selectedItems);

    if (selectedWorkType.sections) {
      payload.section_id = selectedSection;
    }

    if (!selectedWorkType.sections) {
      payload.task_ids = ids;
    }

    console.log('Payload', payload);

    if (unique) {
      if (modalTitle === 'Select Architects' || modalTitle === 'Select Engineers') {
        updateTaskUsers(payload);
      }
      if (modalTitle === 'Select Contractors') {
        updateTaskSPs(payload);
      }
    }
    if (!unique) {
      updateTask({ selectedTaskId, payload });
    }
    setModalOpen(false);
  };

  const handleImageClick = (id, type) => {
    setSelectedTaskId(id); // Set the currently focused task ID

    // Find the task data to get assigned users
    const currentTask = tasks.find((task) => task?.id === id);

    let currentlyAssignedIds = [];

    if (currentTask) {
      if (type === 'engineer') {
        setModalTitle('Select Engineers');
        UsersMutation();
        currentlyAssignedIds =
          currentTask?.engineerLiveTaskMapping?.map((eng) => eng.user?.id) || [];
      } else if (type === 'contractor') {
        setModalTitle('Select Contractors');
        ContractorsMutation();
        currentlyAssignedIds =
          currentTask?.spLiveTaskMapping
            ?.filter((sp) => sp?.user?.serviceProvider?.category_id === 1)
            .map((sp) => sp.user?.id) || [];
        const allids =
          currentTask?.spLiveTaskMapping
            ?.filter((sp) => sp?.user?.serviceProvider?.category_id === 2)
            .map((sp) => sp.user?.id) || [];
        setAllAssignedSPs(allids);
      } else if (type === 'architect') {
        setModalTitle('Select Architects');
        ArchitectsMutation();
        currentlyAssignedIds =
          currentTask?.architectLiveTaskMapping
            ?.filter((sp) => sp?.user?.serviceProvider?.category_id === 2)
            .map((sp) => sp.user?.id) || [];
        const allids =
          currentTask?.architectLiveTaskMapping
            ?.filter((sp) => sp?.user?.serviceProvider?.category_id === 1)
            .map((sp) => sp.user?.id) || [];
        setAllAssignedSPs(allids);
      }
      setSelectedItems(currentlyAssignedIds);
    } else if (id === null && type === 'engineer') {
      // Handle the case for adding engineers to all tasks (CirclePlus button)
      setModalTitle('Select Engineers');
      UsersMutation();
      setUnique(true);
    } else if (id === null && type === 'contractor') {
      // Handle the case for adding contractors to all tasks (CirclePlus button)
      setModalTitle('Select Contractors');
      ContractorsMutation();
      setUnique(true);
    } else if (id === null && type === 'architect') {
      // Handle the case for adding architects to all tasks (CirclePlus button)
      setModalTitle('Select Architects');
      ArchitectsMutation();
      setUnique(true);
    } else {
      // Reset if task not found or for other types if needed
      setModalTitle(`Select ${type.charAt(0).toUpperCase() + type.slice(1)}s`);
      UsersMutation();
      ContractorsMutation();
      ArchitectsMutation();
      setModalData([]);
      setSelectedItems([]);
    }

    setModalOpen(true);
  };

  const handleCreateTasks = () => {
    if (!watch('project')) {
      toast.error('Please select project');
      return;
    }
    if (!watch('template_name')) {
      toast.error('Please select task template');
      return;
    }
    const payload = {
      project_id: watch('project'),
      name: watch('template_name')
    };
    createTask(payload);
  };

  const { mutate: createTask } = useMutation({
    mutationFn: (payload) => createCommonLiveTasks(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success('Tasks created successfully');
      await refetchCommonLiveTask();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error creating common task', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error creating common task');
    }
  });

  const { mutate: cancelCreatedLiveTaskFn } = useMutation({
    mutationFn: (payload) => cancelCreatedLiveTask(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      await refetchCommonLiveTask();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error canceling created live task', err);
      toast.error(
        err?.response?.data?.message || err?.message || 'Error canceling created live task'
      );
    }
  });

  const { mutate: savePreview } = useMutation({
    mutationFn: (payload) => makePreviewFalse(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      await refetchCommonLiveTask();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error saving preview', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error saving preview');
    }
  });

  const formatDate = (dateString) => {
    if (!dateString) return null;

    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' }); // May, Jun, etc.
    const year = date.getFullYear();

    // Add "st", "nd", "rd", "th"
    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return 'th'; // 11th, 12th, 13th
      switch (n % 10) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    };

    return `${day}${getOrdinal(day)} ${month} ${year}`;
  };

  const [state, setState] = useState({
    right: false
  });

  const toggleDrawer = (anchor, open) => {
    setState((prevState) => ({ ...prevState, [anchor]: open }));
  };

  const HandleSavePreview = () => {
    const ids = tasks.map((task) => task?.id);

    const payload = {
      taskType: 'Common',
      project_id: projectId,
      workType_id: selectedWorkType.id
    };

    if (!selectedWorkType.sections) {
      payload.task_ids = ids;
    }

    if (selectedWorkType?.sections) {
      payload.section_id = selectedSection;
    }
    savePreview(payload);
  };

  const HandleCancelCreatedLiveTask = () => {
    const ids = tasks.map((task) => task?.id);

    const payload = {
      project_id: projectId,
      workType_id: selectedWorkType.id
    };

    if (selectedWorkType?.name === 'General') {
      payload.taskType = 'General';
    } else {
      payload.taskType = 'Common';
    }

    if (!selectedWorkType.sections) {
      payload.task_ids = ids;
    }

    if (selectedWorkType?.sections) {
      payload.section_id = selectedSection;
    }
    cancelCreatedLiveTaskFn(payload);
  };

  const handleAddTask = (data) => {
    const payload = {
      ...data,
      prevTask_id: previousTask?.id,
      workType_id: selectedWorkType?.id,
      project_id: previousTask?.project_id
    };
    if (selectedSection) {
      payload.section_id = previousTask?.section_id;
      payload.section_name = previousTask?.section_name;
    }

    AddCommonLive(payload);
  };

  const { mutate: AddCommonLive } = useMutation({
    mutationFn: (payload) =>
      modalType === 'Add' ? addCommonLiveTasks(payload) : updateLiveTask(previousTask?.id, payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success(`Task ${modalType === 'Add' ? 'created' : 'updated'} successfully`);
      setPreviousTask('');
      setIsOpenAddEditModal(false);
      await refetchCommonLiveTask();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error(`Error ${modalType === 'Add' ? 'creating new' : 'updating'}  task`, err);
      toast.error(`Error ${modalType === 'Add' ? 'creating new' : 'updating'} task`);
    }
  });

  const handleOnEdit = (id) => {
    const task = tasks.find((item) => item.id === Number(id)); // Use find() instead of filter()
    if (task) {
      setIsOpenAddEditModal(true);
      setModalType('Edit');
      setPreviousTask(task);
    }
  };

  useEffect(() => {
    setisLoading(isSubmitting);
  }, [isSubmitting]);

  useEffect(() => {
    if (projectId) {
      dispatch(
        setFormData({
          subTab: 'commonTasks',
          data: { projectId }
        })
      );
    }
  }, [projectId]);

  useEffect(() => {
    if (!projects?.length || !AllWorkTypes?.length) return; // wait for both to be fetched

    if (storedFormData.projectId) {
      setValue('project', storedFormData.projectId);
    }

    if (storedFormData.workTypeId) {
      setValue('workType', storedFormData.workTypeId);
      handleChangeWorkType(storedFormData.workTypeId); // safely load sections
    }

    if (storedFormData.sectionId) {
      setActiveTab(storedFormData.sectionId);
    }
  }, [projects, AllWorkTypes]);

  useEffect(() => {
    if (!sections?.length) return;

    if (storedFormData.sectionId && storedFormData.sectionId === workType) {
      setActiveTab(storedFormData.sectionId);
    }
  }, [sections]);

  //delete functions

  const { mutate: handleCheckDelete } = useMutation({
    mutationFn: (id) => checkLiveTaskDelete(id),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (res, id) => {
      setIsSubmitting(false);
      const task = tasks?.find((item) => parseInt(item.id) === parseInt(id));
      const taskName = task?.name || 'Task';
      if (res.canDelete) {
        setCanDelete('yes');
        setResData({ name: taskName });
        setSelectedIds([parseInt(id)]);
      } else {
        // Fallback if not found
        setResData({ ...res, name: taskName });
        setCanDelete('no');
      }
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error checking dependencies', err);
      toast.error('Error checking dependencies');
    }
  });

  const { mutate: handleDeleteFn } = useMutation({
    mutationFn: (payload) => deleteLiveTask(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: () => {
      setIsSubmitting(false);
      toast.success('Task Deleted Successfully');
      refetchCommonLiveTask();
      setCanDelete(null);
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error deleting task', err);
      toast.error('Error deleting task');
    }
  });

  const HandleDelete = (data) => {
    const payload = { ids: data };
    handleDeleteFn(payload);
  };

  const calculateDelay = (task) => {
    if (!task?.planned_end_date) return '---';

    const plannedEnd = new Date(task?.planned_end_date);
    const today = new Date();

    let delay;

    if (task?.status === 'To Do' || task?.status === 'In Progress') {
      delay = Math.floor((today - plannedEnd) / (1000 * 60 * 60 * 24)); // days
    } else if (task?.status === 'Completed') {
      if (!task?.actual_end_date) return '---';
      const actualEnd = new Date(task?.actual_end_date);
      delay = Math.floor((actualEnd - plannedEnd) / (1000 * 60 * 60 * 24)); // days
    } else {
      return '---';
    }

    return delay > 0 ? `${delay} days` : '---';
  };

  const { mutate: handleBulkDeleteFn } = useMutation({
    mutationFn: (payload) => bulkDeleteLiveTask(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: () => {
      setIsSubmitting(false);
      toast.success('Task Deleted Successfully');
      refetchCommonLiveTask();
      setCanDelete(null);
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error deleting task', err);
      toast.error('Error deleting task');
    }
  });

  const handleSelectAll = async (e) => {
    const checked = e.target.checked;
    if (checked) {
      const results = tasks.map((item) => item.id);
      setSelectItems(results);
    } else {
      setSelectItems([]);
    }
  };

  // Update selectAll state based on selectedItems
  useEffect(() => {
    if (tasks.length > 0 && selectedItems.length === tasks.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selectedItems, tasks.length]);

  // Update selectItems state based on selectedItems for backward compatibility
  useEffect(() => {
    setSelectItems(selectedItems);
  }, [selectedItems]);

  const HandleBulkDelete = (selectedIds) => {
    const payload = { taskType: 'Common', project_id: projectId, workType_id: selectedWorkType.id };

    // console.log('Selected Items:', selectedItems);
    const ids =
      selectedIds && selectedIds.length > 0 ? selectedIds : tasks?.map((task) => task?.id);
    if (selectedWorkType.sections) {
      payload.section_id = selectedSection;
    }

    if (!selectedWorkType.sections) {
      payload.task_ids = ids;
    }
    handleBulkDeleteFn(payload);
  };

  // Engineer bulk assignment handler
  const handleBulkEngineerAssignment = async ({
    selectedTasks,
    selectedEngineers,
    selectedWorkType
  }) => {
    const payload = {
      taskIds: selectedTasks,
      engineer_ids: selectedEngineers
    };

    try {
      console.log('Bulk Engineer Assignment Payload:', payload);
      await assignUsersByCheckbox(payload);

      // Small delay to ensure backend processes the changes
      await new Promise((resolve) => setTimeout(resolve, 500));

      toast.success('Engineers assigned successfully');

      // Track success
      mixpanel.track('Bulk Engineer Assignment', {
        user_id: userId,
        task_count: selectedTasks.length,
        engineer_count: selectedEngineers.length,
        work_type: selectedWorkType
      });

      setIsEngineerBulkAssignModalOpen(false);
      await refetchCommonLiveTask();
    } catch (error) {
      console.error('Error assigning engineers:', error);
      toast.error('Error assigning engineers');

      // Track error
      mixpanel.track('Bulk Engineer Assignment Error', {
        user_id: userId,
        error: error.message
      });
    }
  };

  // New functions for assign users functionality
  const handleAssignUsersClick = () => {
    setIsAssignUsersModalOpen(true);
    setSelectedEngineers([]);
    setSelectedContractors([]);
  };

  const handleAssignUsersSubmit = async () => {
    if (selectedEngineers.length === 0 && selectedContractors.length === 0) {
      toast.error('Please select at least one employee or contractor');
      return;
    }

    const payload = {
      taskIds: selectedTasks,
      engineer_ids: selectedEngineers,
      contractor_ids: selectedContractors
    };

    try {
      // You can call your API here with the payload
      console.log('Assign Users Payload:', payload);
      await assignUsersByCheckbox(payload);

      // Small delay to ensure backend processes the changes
      await new Promise((resolve) => setTimeout(resolve, 500));

      toast.success('Users assigned successfully');
      setIsAssignUsersModalOpen(false);
      setSelectedTasks([]);
      setSelectedEngineers([]);
      setSelectedContractors([]);
      await refetchCommonLiveTask();
    } catch (error) {
      console.error('Error assigning users:', error);
      toast.error('Error assigning users');
    }
  };

  const HandleFunctionCalls = (id, checked) => {
    if (checked) {
      setSelectedTasks((prev) => [...prev, id]);
    } else {
      setSelectedTasks((prev) => prev.filter((item) => item !== id));
    }
  };

  // Bulk completion handlers
  const handleBulkCompleteClick = () => {
    setIsBulkCompleteModalOpen(true);
  };

  const handleBulkCompleteSubmit = async (payload) => {
    try {
      // Add project_id and workType_id to the payload
      const fullPayload = {
        task_ids: payload.taskIds
      };

      console.log('fullPayload', fullPayload);
      // Call bulk completion API
      await bulkCompleteTasks(fullPayload);

      toast.success(`${payload.taskIds.length} task(s) completed successfully`);
      setIsBulkCompleteModalOpen(false);
      await refetchCommonLiveTask();
    } catch (error) {
      console.error('Error completing tasks:', error);
      toast.error('Error completing tasks');
    }
  };

  return (
    <div className="mt-[8rem]">
      {isOpenAddEditModal && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={65}
          name={modalType === 'Edit' ? 'Edit Task' : 'Add Task'}
          onClose={() => setIsOpenAddEditModal(false)}>
          <AddEditCommonLiveTask
            isSubmitting={isSubmitting}
            onSubmit={handleAddTask}
            onClose={() => setIsOpenAddEditModal(false)}
            modalType={modalType}
            setModalType={setModalType}
            tasks={tasks}
            selectedTask={previousTask}
            taskPositionType={taskPositionType}
          />
        </Modal>
      )}

      {modalOpen && (
        <Modal isDirty={true} width={30} name={modalTitle} onClose={() => setModalOpen(false)}>
          <div className="modal">
            <div className="modal-body max-h-[300px] overflow-y-auto mt-4">
              {modalTitle === 'Select Engineers' && (
                <div className="mb-2 text-sm font-medium text-gray-600 bg-blue-50 p-2 rounded">
                  Required: 1 Manager · Executive optional
                </div>
              )}
              {modalData && modalData?.length > 0 ? (
                modalData.map((item) => {
                  const isSelected = selectedItems.includes(item.user?.id);
                  const initials = item.user?.name
                    .split(' ')
                    .map((word) => word[0])
                    .join('')
                    .toUpperCase();

                  // Check if this engineer should be disabled
                  let isDisabled = false;
                  if (modalTitle === 'Select Engineers' && !isSelected) {
                    const selectedEngineers = modalData.filter((u) =>
                      selectedItems.includes(u.user?.id)
                    );
                    const mediumLevelCount = selectedEngineers.filter(
                      (u) => u.user?.level === 'Medium'
                    ).length;
                    const lowLevelCount = selectedEngineers.filter(
                      (u) => u.user?.level === 'Low'
                    ).length;

                    if (item.user?.level === 'Medium' && mediumLevelCount >= 1) {
                      isDisabled = true;
                    }
                    if (item.user?.level === 'Low' && lowLevelCount >= 1) {
                      isDisabled = true;
                    }
                  }

                  return (
                    <div
                      key={item.id || item.user?.id}
                      onClick={() => !isDisabled && toggleSelect(item.user?.id)}
                      className={`flex items-center gap-3 p-3 mb-2 rounded-lg border ${isSelected
                        ? 'bg-green-100 cursor-pointer'
                        : isDisabled
                          ? 'bg-gray-100 cursor-not-allowed opacity-50'
                          : 'bg-white cursor-pointer hover:bg-gray-50'
                        }`}>
                      <div
                        className={`w-8 h-8 rounded-full text-white flex items-center justify-center font-semibold text-sm ${getUserColor(
                          item.user?.id
                        )}`}>
                        {initials}
                      </div>
                      <div className="flex-1">
                        <span className="text-gray-800 capitalize">{item.user?.name}</span>
                        {modalTitle === 'Select Engineers' && item.user?.level && (
                          <span className="ml-2 text-sm text-gray-500">
                            ({item.user.level === 'Medium' ? 'Manager' : 'Executive'})
                          </span>
                        )}
                      </div>
                      {isDisabled && (
                        <div className="text-xs text-gray-400">
                          {item.user?.level === 'Medium' ? 'Max 1 Medium' : 'Max 1 Low'}
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                <p className="text-center text-gray-500">No users to display</p>
              )}
            </div>

            {modalData && modalData?.length > 0 && (
              <div className="flex gap-2 mt-5 justify-between items-center">
                {(modalTitle === 'Select Contractors' || modalTitle === 'Select Architects') && (
                  <button
                    onClick={() => setShowAddSPModal(true)}
                    className="text-blue-500 hover:text-blue-700 text-sm font-semibold underline cursor-pointer">
                    Add
                  </button>
                )}
                <div className="flex gap-2 ml-auto">
                  <Button
                    customStyle={{ width: '7rem' }}
                    displayType={'secondary'}
                    onClick={() => {
                      setModalOpen(false);
                      setModalData([]);
                    }}>
                    Close
                  </Button>
                  <Button customStyle={{ width: '7rem' }} onClick={handleAddClick}>
                    Add
                  </Button>
                </div>
              </div>
            )}
          </div>
        </Modal>
      )}

      {isDateModalOpen && (
        <div className="h-screen w-screen bg-[#0000002a] z-[90] flex justify-center items-center fixed top-0 left-0">
          <div className="flex flex-col items-center p-1  bg-white rounded-lg">
            <DatePicker selected={tempDate} onChange={(date) => setTempDate(date)} inline />

            <div className="flex gap-4 mt-3 w-[100%] justify-end">
              <Button
                type="button"
                onClick={() => setIsDateModalOpen(false)}
                displayType="secondary">
                Cancel
              </Button>

              <Button type="button" onClick={() => handleDateSubmit()} disabled={!tempDate}>
                OK
              </Button>
            </div>
          </div>
        </div>
      )}

      {canDelete === 'no' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={`Cannot delete '${resData?.name || 'this task'}'`}
          onClose={() => {
            setCanDelete(null);
            setIsBulk(false);
            setSelectItems([]);
          }}
          width={45}>
          <div className="flex flex-col justify-center align-center ">
            <p className="text-center">
              Looks like this task has dependencies, please delete following task to proceed
            </p>
            <div className="flex justify-start, align-middle flex-wrap bg-[#f5f7f8] p-2 rounded-[5px] mt-4">
              {resData &&
                resData.reason?.map((r, index) => (
                  <span className="mt-[2px] mr-[4px] text-[#535353]" key={index}>
                    {index + 1}.{r}
                    {index < resData.reason.length - 1 ? ', ' : ''}
                  </span>
                ))}
            </div>
          </div>
          <div className="flex flex-col justify-start items-center mt-4 w-[100%]  bg-[#f7f4d0] pt-[4px] pb-[4px] pl-2 pr-2 rounded-[4px]">
            <div className="flex justify-between w-[99%] items-center bg-white p-2 pt-1 pb-1">
              <p>Would you like to delete more tasks ?</p>
              <div
                onClick={(e) => {
                  setIsBulk(!isBulk);
                  setSelectedItems([]);
                  handleSelectAll(e);
                }}
                className="bg-amber-100 p-2 pt-1 pb-1 rounded-[5px] flex justify-center items-center gap-2 cursor-pointer">
                Bulk Delete
                <input
                  type="checkbox"
                  checked={isBulk}
                  readOnly
                  className="outline-none border-none"
                />
              </div>
            </div>
            {isBulk && (
              <div className="pl-[10px] w-[100%] pr-[19px] mt-2 mb-2 max-h-[14rem] overflow-auto">
                {tasks &&
                  tasks.map((c, index) => (
                    <div key={index} className="flex justify-between items-center text-[#5b5b5b]">
                      {index + 1}. {c.name}
                      <input
                        className="outline-none border-none"
                        type="checkbox"
                        checked={selectedItems.includes(c.id)}
                      />
                    </div>
                  ))}
              </div>
            )}
          </div>

          <div className="w-full flex justify-end items-center space-x-4 mt-8">
            <Button
              type="reset"
              onClick={() => {
                setCanDelete(null);
                setIsBulk(false);
                setSelectedItems([]);
              }}
              displayType="secondary">
              Cancel
            </Button>
            <Button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                HandleBulkDelete(selectedItems);
              }}
              disabled={isSubmitting || selectedItems.length === 0}
              displayType="primary-red">
              Delete
            </Button>
          </div>
        </Modal>
      )}

      {canDelete === 'yes' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={'Confirmation'}
          onClose={() => {
            setCanDelete(null);
            setSelectedIds([]);
          }}
          width={45}>
          <DeleteConfirmationModal
            name={resData.name}
            title={'task'}
            onClose={() => setCanDelete(null)}
            data={tasks}
            type={'commonLiveTask'}
            setCanDelete={setCanDelete}
            onDeleteClick={HandleDelete}
            setSelectedIds={setSelectedIds}
            selectedIds={selectedIds}
          />
        </Modal>
      )}

      {/* Assign Users Modal */}
      {isAssignUsersModalOpen && (
        <Modal
          isDirty={true}
          width={50}
          name="Assign Users to Tasks"
          onClose={() => setIsAssignUsersModalOpen(false)}>
          <UserSelectionModal
            selectedTasks={selectedTasks}
            allUsers={AllUsers}
            selectedEngineers={selectedEngineers}
            setSelectedEngineers={setSelectedEngineers}
            selectedContractors={selectedContractors}
            setSelectedContractors={setSelectedContractors}
            setIsAssignUsersModalOpen={setIsAssignUsersModalOpen}
            handleAssignUsersSubmit={handleAssignUsersSubmit}
            AllContractors={AllContractors}
            tasks={tasks}
          />
        </Modal>
      )}

      {/* Bulk Complete Modal */}
      {isBulkCompleteModalOpen && (
        <BulkCompleteModal
          isOpen={isBulkCompleteModalOpen}
          onClose={() => setIsBulkCompleteModalOpen(false)}
          tasks={tasks}
          workTypes={transformedDataWorkTypes}
          onBulkComplete={handleBulkCompleteSubmit}
          isSubmitting={isSubmitting}
          showWorktypeSelection={false}
          title="Mark Tasks as Complete"
        />
      )}

      <div
        ref={toolbarRef}
        style={{ top: subTabTop }}
        className={`flex justify-between items-end gap-2 fixed z-30 border bg-white px-6 py-3 pb-6 transition-all duration-300 ease-in-out ${collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
          }`}>
        <form
          onSubmit={handleSubmit(HandleCreate)}
          className="flex w-[100%] items-end justify-between gap-3"
        >
          <div className="flex w-[min(720px,70%)] min-w-0 flex-wrap items-end gap-3">
            <div className="min-w-[220px] max-w-[320px] flex-[1.35]">
              <FormInput
                width={100}
                label={'Project'}
                register={register}
                register_key={'project'}
                isRequired={true}
                type={'dropdown'}
                options={projectsForDropdown}
                validation={{ required: 'Project is required' }}
                errors={errors}
              />
            </div>

            <div className="min-w-[160px] max-w-[240px] flex-1">
              <FormInput
                width={100}
                label={'Work Type'}
                register={register}
                register_key={'workType'}
                isRequired={true}
                type={'dropdown'}
                options={transformedDataWorkTypes}
                onDropdownChange={(id) => {
                  handleChangeWorkType(id);
                }}
                validation={{ required: 'Work type is required' }}
                errors={errors}
              />
            </div>

            {selectedWorkType?.type === 'Common' &&
              (selectedWorkType?.sections ||
                (!selectedWorkType?.sections && tasks?.length < 1)) && (
                <div className="min-w-[180px] max-w-[260px] flex-1">
                  <FormInput
                    width={100}
                    label={'Task Template'}
                    register={register}
                    register_key={'template_name'}
                    isRequired={true}
                    type={'dropdown'}
                    options={[
                      { label: 'Select Task Template', value: '', disabled: true, selected: true },
                      ...transformedDataTaskTemplates
                    ]}
                    validation={{ required: 'Task template is required' }}
                    errors={errors}
                  />
                </div>
              )}
          </div>
          {selectedWorkType?.type === 'Common' && selectedWorkType?.sections && (
            <Button
              displayType={'secondary'}
              customStyle={{
                height: '2.5rem',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
              type="submit">
              {tasks && tasks?.length < 1 ? 'Create' : 'Add Section'}
            </Button>
          )}
        </form>

        {tasks &&
          tasks?.length < 1 &&
          selectedWorkType?.type === 'Common' &&
          !selectedWorkType?.sections && <Button onClick={handleCreateTasks}> Create</Button>}

        {!hidePreviewTable && (
          <div className="flex justify-center gap-4">
            {/* {selectedTasks?.length >= 2 && (
              <Button
                type={'button'}
                customStyle={{ paddingLeft: '2rem', paddingRight: '2rem', width: '10rem' }}
                onClick={handleAssignUsersClick}>
                Assign Users
              </Button>
            )} */}
            {tasks && tasks?.length > 0 && (
              <Button
                type={'button'}
                customStyle={{ paddingLeft: ' 1rem', paddingRight: '1rem', whiteSpace: 'nowrap' }}
                onClick={handleBulkCompleteClick}>
                Mark as Complete
              </Button>
            )}
            <Button
              type={'button'}
              disabled={!hidePreviewBtn}
              customStyle={{ paddingLeft: '3rem', paddingRight: '3rem' }}
              onClick={HandleSavePreview}>
              Save
            </Button>
            {tasks && tasks?.length > 0 && (
              <Button
                type={'button'}
                displayType={'secondary-red'}
                customStyle={{ paddingLeft: '3rem', paddingRight: '3rem' }}
                onClick={HandleCancelCreatedLiveTask}>
                Cancel
              </Button>
            )}
          </div>
        )}
        {hidePreviewTable && (
          <div className="flex justify-center gap-4">
            <Button
              onClick={() => setIsBulkActionModalOpen(true)}
              customStyle={{ paddingLeft: ' 1rem', paddingRight: '1rem', whiteSpace: 'nowrap' }}>
              Bulk Actions
            </Button>
            <Button
              onClick={() =>
                navigate('/builder/operations/tasks/ganttChart', {
                  state: { title: 'Common Tasks', data: tasks }
                })
              }
              customStyle={{ paddingLeft: ' 1rem', paddingRight: '1rem', whiteSpace: 'nowrap' }}>
              Gantt Chart
            </Button>
          </div>
        )}
      </div>

      {selectedWorkType?.type === 'Common' &&
        selectedWorkType?.sections &&
        sections &&
        sections?.length > 0 && (
          <div
            style={{ top: `calc(${subTabTop} + ${toolbarHeight}px)` }}
            className={`fixed z-20 bg-white px-6 py-3 border transition-all duration-300 ease-in-out ${collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
              }`}>
            <div className="relative w-full max-w-full">
              {/* Horizontally scrollable container without scrollbar */}
              <div
                className="flex gap-8 pb-2 overflow-x-auto scrollbar-hide scroll-smooth"
                style={{
                  scrollbarWidth: 'none' /* Firefox */,
                  msOverflowStyle: 'none' /* IE and Edge */
                }}>
                {sections.map((section, index) => (
                  <button
                    key={section.section_id}
                    ref={(el) => (buttonsRef.current[index] = el)}
                    className={`text-[1rem] font-semibold transition-colors duration-200 whitespace-nowrap flex-shrink-0 ${activeTab === section.section_id
                      ? 'text-[#2A565E]'
                      : 'text-gray-400 hover:text-gray-600'
                      }`}
                    onClick={() => handleTabChange(section.section_id)}>
                    {section.section_name}
                  </button>
                ))}
              </div>
              {/* Single underline */}
              <div
                className="absolute bottom-0 left-0 h-[2px] bg-[#2A565E] transition-all duration-300"
                style={{
                  width: `${barStyle.width}px`,
                  transform: `translateX(${barStyle.translateX}px)`
                }}
              />
            </div>
          </div>
        )}

      {!hidePreviewTable && (
        <div style={{ paddingTop: contentTop(Boolean(sections && sections.length > 0)) }}>
          <div className="shadow overflow-auto rounded-lg">
            <table className="min-w-full rounded-t-xl text-left   shadow">
              <thead className=" bg-gray-200 !text-gray-600 w-full ">
                <tr className="font-normal h-[3rem] w-full">
                  {/* <th className="px-4 py-2 border-b font-normal">
                    Selected ( {selectedItems.length} )
                  </th> */}
                  <th className="px-4 py-2 border-b font-normal">ID</th>
                  <th className="px-4 py-2 border-b font-normal">Task Name</th>
                  <th className="px-4 py-2 border-b font-normal">Planned Start Date</th>
                  <th className="px-4 py-2 border-b font-normal">Planned End Date</th>
                  <th className="px-4 py-2 border-b relative font-normal">
                    <div className="flex gap-2 justify-center items-center">
                      Assign Employee
                      {tasks && tasks?.length > 0 && (
                        <CirclePlus
                          height={15}
                          width={15}
                          className="cursor-pointer"
                          onClick={(e) => {
                            UsersMutation();
                            setIsEngineerBulkAssignModalOpen(true);
                            e.stopPropagation();
                          }}
                        />
                      )}
                    </div>
                  </th>
                  <th className="px-4 py-2 border-b font-normal">
                    <div className="flex gap-2 justify-center items-center">
                      Assign Contractor
                      {tasks && tasks?.length > 0 && (
                        <CirclePlus
                          height={15}
                          width={15}
                          className="cursor-pointer"
                          onClick={(e) => {
                            handleImageClick(null, 'contractor');
                            e.stopPropagation();
                          }}
                        />
                      )}
                    </div>
                  </th>
                  <th className="px-4 py-2 border-b font-normal">
                    <div className="flex gap-2 justify-center items-center">
                      Assign Architect
                      {tasks && tasks?.length > 0 && (
                        <CirclePlus
                          height={15}
                          width={15}
                          className="cursor-pointer"
                          onClick={(e) => {
                            handleImageClick(null, 'architect');
                            e.stopPropagation();
                          }}
                        />
                      )}
                    </div>
                  </th>
                  <th className="px-4 py-2 border-b font-normal">Status</th>
                </tr>
              </thead>
              <tbody>
                {tasks && tasks?.length > 0 ? (
                  tasks?.map((task, index) => {
                    return (
                      <React.Fragment key={task?.id}>
                        <tr
                          className="border-b hover:bg-gray-50 bg-white h-[3.5rem]"
                          onClick={() => {
                            setApiType('common');
                            setSelectedTaskId(task?.id);
                            toggleDrawer('right', true);
                          }}>
                          {/* <td className="px-4 py-2" onClick={(e) => e.stopPropagation()}>
                            <input
                              type="checkbox"
                              checked={selectedTasks.includes(task?.id)}
                              onChange={(e) => HandleFunctionCalls(task?.id, e.target.checked)}
                              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded"
                            />
                          </td> */}
                          <td className="px-4 py-2 text-blue-600 underline cursor-pointer">
                            {index + 1}
                          </td>
                          <td className="px-4 py-2">{task?.name}</td>
                          <td className="px-4 py-2">
                            {task.status !== 'Completed' &&
                              (task.planned_start_date ? (
                                formatDate(task?.planned_start_date)
                              ) : task?.dependencies?.length > 0 &&
                                !task?.dependencies?.some(
                                  (item) => item?.dependency?.status === 'Completed'
                                ) ? (
                                '--'
                              ) : (
                                <img
                                  className="cursor-pointer"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDateClick(task?.id, 'start');
                                  }}
                                  src={CalenderIcon}
                                  alt="calenderIcon"
                                />
                              ))}
                          </td>

                          <td className="px-4 py-2">
                            {task?.planned_end_date ? formatDate(task?.planned_end_date) : '--'}
                          </td>

                          <td className="px-4 py-2">
                            <div className="flex items-center justify-center w-full relative ">
                              {task?.engineerLiveTaskMapping?.length > 0 ? (
                                <div
                                  className="flex -space-x-3 cursor-pointer"
                                  onClick={(e) => {
                                    handleImageClick(task?.id, 'engineer');
                                    setUnique(false);
                                    e.stopPropagation();
                                  }}>
                                  {task?.engineerLiveTaskMapping.map((engineer, index) => (
                                    <div
                                      key={engineer.id}
                                      className={`w-6 h-6 rounded-full ${getUserColor(engineer?.user?.id)} text-white flex items-center justify-center text-[0.8rem] font-semibold border-2 border-white leading-none`}
                                      style={{
                                        zIndex: task?.engineerLiveTaskMapping?.length - index
                                      }}>
                                      {engineer?.user?.name?.charAt(0).toUpperCase()}
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                <img
                                  src={DP}
                                  alt=""
                                  className="cursor-pointer"
                                  onClick={(e) => {
                                    handleImageClick(task?.id, 'engineer');
                                    setUnique(false);
                                    e.stopPropagation();
                                  }}
                                />
                              )}
                            </div>
                          </td>

                          <td className="px-4 py-2">
                            <div className="flex items-center justify-center w-full relative ">
                              {task?.spLiveTaskMapping?.some(
                                (contractor) => contractor?.user?.serviceProvider?.category_id === 1
                              ) ? (
                                <div
                                  className="flex -space-x-3 cursor-pointer"
                                  onClick={(e) => {
                                    handleImageClick(task?.id, 'contractor');
                                    e.stopPropagation();
                                    setUnique(false);
                                  }}>
                                  {task?.spLiveTaskMapping
                                    .filter(
                                      (contractor) =>
                                        contractor?.user?.serviceProvider?.category_id === 1
                                    )
                                    .map((contractor, index) => (
                                      <div
                                        key={contractor.id}
                                        className={`w-6 h-6 rounded-full ${getUserColor(contractor?.user?.id)} text-white flex items-center justify-center text-[0.8rem] font-semibold border-2 border-white leading-none`}
                                        style={{ zIndex: task?.spLiveTaskMapping?.length - index }}>
                                        {contractor?.user?.name?.charAt(0).toUpperCase()}
                                      </div>
                                    ))}
                                </div>
                              ) : (
                                <img
                                  src={DP}
                                  alt=""
                                  className="cursor-pointer"
                                  onClick={(e) => {
                                    handleImageClick(task?.id, 'contractor');
                                    e.stopPropagation();
                                    setUnique(false);
                                  }}
                                />
                              )}
                            </div>
                          </td>
                          <td className="px-4 py-2">
                            <div className="flex items-center justify-center w-full relative">
                              {task?.drawing_required ? (
                                task?.architectLiveTaskMapping?.some(
                                  (architect) => architect?.user?.serviceProvider?.category_id === 2
                                ) ? (
                                  <div
                                    className="flex -space-x-3 cursor-pointer"
                                    onClick={(e) => {
                                      handleImageClick(task?.id, 'architect');
                                      e.stopPropagation();
                                      setUnique(false);
                                    }}>
                                    {task?.architectLiveTaskMapping
                                      .filter(
                                        (architect) =>
                                          architect?.user?.serviceProvider?.category_id === 2
                                      )
                                      .map((architect, index) => (
                                        <div
                                          key={architect.id}
                                          className={`w-6 h-6 rounded-full ${getUserColor(architect?.user?.id)} text-white flex items-center justify-center text-[0.8rem] font-semibold border-2 border-white leading-none`}
                                          style={{
                                            zIndex: task?.architectLiveTaskMapping?.length - index
                                          }}>
                                          {architect?.user?.name?.charAt(0).toUpperCase()}
                                        </div>
                                      ))}
                                  </div>
                                ) : (
                                  <img
                                    src={DP}
                                    alt=""
                                    className="cursor-pointer"
                                    onClick={(e) => {
                                      handleImageClick(task?.id, 'architect');
                                      e.stopPropagation();
                                      setUnique(false);
                                    }}
                                  />
                                )
                              ) : (
                                'N/A'
                              )}
                            </div>
                          </td>

                          <td className="px-4 py-2">
                            <TableData data={task.status} />
                          </td>

                          {/* <td className="px-4 py-2">
                        {Number(task?.material_budget) + Number(task?.labour_budget) || '---'}
                      </td>
                      <td className="px-4 py-2">
                        {task?.materialTaskMapping?.length > 0
                          ? task?.materialTaskMapping.map((item) => item.name).join(', ')
                          : '---'}
                      </td> */}
                        </tr>
                      </React.Fragment>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={9} className="text-center py-7">
                      <div className="flex flex-col items-center justify-center">
                        <img
                          src={noDataIcon}
                          alt="No Data"
                          className="w-[25rem] h-[20rem] object-cover"
                        />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* <PaginationComponent
          page={currentPage}
          totalPages={Math.ceil(tasks?.length / itemsPerPage)}
          onPageChange={handlePageChange}
          isFetching={isFetching}
        /> */}
          </div>
        </div>
      )}
      {hidePreviewTable && (
        <div style={{ paddingTop: contentTop(Boolean(sections && sections.length > 0)) }}>
          <div className="shadow overflow-auto rounded-lg">
            <table className="min-w-full rounded-t-xl text-left">
              <thead className=" bg-gray-200 !text-gray-600 ">
                <tr className="font-normal h-[3rem]">
                  <th className="px-3 py-2 border-b font-normal ">ID</th>
                  <th className="px-3 py-2 border-b font-normal">Task Name</th>
                  <th className="px-3 py-2 border-b font-normal">Planned Start Date</th>
                  <th className="px-3 py-2 border-b font-normal">Planned End Date</th>
                  <th className="px-3 py-2 border-b font-normal">Actual Start Date</th>
                  <th className="px-3 py-2 border-b font-normal">Actual End Date</th>
                  <th className="px-3 py-2 border-b font-normal">Status</th>
                  <th className="px-3 py-2 border-b font-normal">Task Delay</th>
                  <th className="px-3 py-2 border-b font-normal">Actions</th>
                </tr>
              </thead>
              <tbody>
                {tasks?.map((task, index) => {
                  return (
                    <React.Fragment key={task?.id}>
                      <tr
                        className="border-b hover:bg-gray-50 bg-white h-[3.5rem]"
                        onClick={() => {
                          setApiType('common');
                          setSelectedTaskId(task?.id);
                          toggleDrawer('right', true);
                        }}>
                        <td className="px-4 py-2 text-blue-600 underline cursor-pointer">
                          {index + 1}
                        </td>
                        <td className="px-4 py-2">{task?.name}</td>
                        <td className="px-4 py-2">
                          {formatDate(task?.planned_start_date) || '--'}
                        </td>
                        <td className="px-4 py-2">{formatDate(task?.planned_end_date) || '--'}</td>
                        <td className="px-4 py-2">{formatDate(task?.actual_start_date) || '--'}</td>
                        <td className="px-4 py-2">{formatDate(task?.actual_end_date) || '--'}</td>
                        <td className="px-4 py-2">{task?.status}</td>
                        <td className="px-4 py-2 text-red-600">{calculateDelay(task)}</td>
                        <td className="px-4 py-[1.45rem] flex space-x-2 items-center text-gray-600">
                          {task?.status !== 'Completed' && (
                            <Pencil
                              className="w-4 h-4 cursor-pointer hover:text-blue-500"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleOnEdit(task?.id);
                                setTaskPositionType('First');
                              }}
                            />
                          )}
                          <div className="relative group">
                            <Plus
                              className="w-4 h-4 cursor-pointer hover:text-purple-500"
                              onClick={(e) => {
                                e.stopPropagation();
                                setIsOpenAddEditModal(true);
                                setModalType('Add');
                                setPreviousTask(task);
                                setTaskPositionType('First');
                              }}
                            />
                            <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 whitespace-nowrap text-xs bg-black text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                              Add new task
                            </div>
                          </div>
                          <Trash
                            className="w-4 h-4 cursor-pointer hover:text-red-500"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCheckDelete(task?.id);
                            }}
                          />
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <SwipeableDrawer
        anchor={'right'}
        open={state['right']}
        onClose={() => {
          toggleDrawer('right', false);
          setSelectedTaskId(null);
        }}
        onOpen={() => () => toggleDrawer('right', true)}>
        <TaskDetailsPage
          apiType={apiType}
          taskID={selectedTaskId}
          drawerState={state?.right}
          callApi={refetchCommonLiveTask}
        />
      </SwipeableDrawer>

      {/* Engineer Bulk Assignment Modal */}
      <BulkEngineerAssignmentModal
        isOpen={isEngineerBulkAssignModalOpen}
        onClose={() => setIsEngineerBulkAssignModalOpen(false)}
        workTypes={[]}
        allUsers={AllUsers}
        tasks={tasks}
        onAssignEngineers={handleBulkEngineerAssignment}
        isSubmitting={isSubmitting}
        getUserColor={getUserColor}
        preSelectedWorkType={selectedWorkType?.id}
        setIsSubmitting={setIsSubmitting}
      />

      {/* Bulk Action Modal */}
      {isBulkActionModalOpen && (
        <BulkActionModal
          isOpen={isBulkActionModalOpen}
          onClose={() => setIsBulkActionModalOpen(false)}
          onActionSelect={(actionType) => {
            setIsBulkActionModalOpen(false);

            switch (actionType) {
              case 'assign_employee':
                UsersMutation();
                setIsEngineerBulkAssignModalOpen(true);
                break;
              case 'assign_contractor':
                handleImageClick(null, 'contractor');
                break;
              case 'assign_architect':
                handleImageClick(null, 'architect');
                break;
              case 'complete_task':
                setIsBulkCompleteModalOpen(true);
                break;
              default:
                break;
            }
          }}
          isSubmitting={isSubmitting}
        />
      )}

      {/* Add Service Provider Modal */}
      {showAddSPModal && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={60}
          name="Add Service Provider"
          onClose={() => setShowAddSPModal(false)}>
          <AddServiceProvider
            isSubmitting={isSubmittingSP}
            modalType="Add"
            onSubmit={handleCreateServiceProvider}
            onClose={() => setShowAddSPModal(false)}
            selectedServiceProvider={null}
            setSelectedServiceProvider={() => { }}
            setModalType={() => { }}
            setOpenAddUser={setShowAddSPModal}
            OpenAddUser={showAddSPModal}
            refetchServiceProviders={() => { }}
          />
        </Modal>
      )}
    </div>
  );
};

export default CommanLiveTasks;
